import { MutationTree } from 'vuex';
import { TransportsState } from './types';

export const mutations: MutationTree<TransportsState> = {
    setTransports:(state, data) => {
        state.transports = data
    },
    setTransportsMultichannel:(state, data) => {
        state.transportsMultichannel = data
    }
};